import React from 'react';

export const useBlurAction = () => {
  const ref = React.useRef(null);

  const queueDelayedBlur = (callback) => {
    ref.current = setTimeout(() => {
      callback();
    }, 200);
  };

  const clearDelayedBlur = () => {
    if (ref.current) {
      clearTimeout(ref.current);
      ref.current = null;
    }
  };

  React.useEffect(() => {
    return () => {
      if (ref.current) {
        clearTimeout(ref.current);
        ref.current = null;
      }
    };
  }, []);

  return React.useMemo(() => ({ queueDelayedBlur, clearDelayedBlur }), []);
};
